var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisiblePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75L19.5 20.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5215 14.775C13.8333 15.4054 12.9329 15.7535 11.9996 15.75C11.2427 15.7499 10.5036 15.5208 9.87935 15.0928C9.25512 14.6648 8.77502 14.0579 8.50216 13.3519C8.2293 12.6459 8.17646 11.8739 8.35058 11.1373C8.5247 10.4007 8.91764 9.73406 9.47773 9.22498",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 6.43127C3.1125 8.36252 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C13.7574 18.7643 15.4929 18.3594 17.0625 17.5688",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5555 15.8532C21.5992 14.025 22.4992 12 22.4992 12C22.4992 12 19.4992 5.25002 11.9992 5.25002C11.349 5.24874 10.6999 5.30205 10.0586 5.4094",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 8.31567C13.5006 8.46678 14.2273 8.87317 14.7735 9.47353C15.3198 10.0739 15.6559 10.8356 15.7312 11.6438",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisiblePassword);
export default __webpack_public_path__ + "static/media/invisible-password.412c28c8e33b6ab8560834c24f54fe4f.svg";
export { ForwardRef as ReactComponent };